'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
var fakeIndex = 'fakeIndex';
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | January
 * `en-us` | January
 * `es` | enero
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/month_for_formatted_date/1/name
 */
var form = 'name';
lingojsCore.registerDynamicTags(lingojsCore.t('month_for_formatted_date', fakeIndex, 'name'));

module.exports = form;
//# sourceMappingURL=index.js.map
